module.exports = __webpack_public_path__ + "media/invoice/icon_fifth-d8ab9e35.svg";